exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "wage-advance-modal .modal:not(.responsiveMobile) .modal-content{margin-left:auto;margin-right:auto;margin-top:70px;padding:50px}wage-advance-modal .modal:not(.responsiveMobile) confirm-close-modal .modal-content,wage-advance-modal .modal:not(.responsiveMobile) failed-action .modal-content,wage-advance-modal .modal:not(.responsiveMobile) successful-action .modal-content{width:520px}wage-advance-modal .modal:not(.responsiveMobile) confirm-close-modal .modal-content .modal-body .description,wage-advance-modal .modal:not(.responsiveMobile) failed-action .modal-content .modal-body .description,wage-advance-modal .modal:not(.responsiveMobile) successful-action .modal-content .modal-body .description{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/wageAdvance/wageAdvanceModal/wageAdvanceModal.scss
// module id = 2146
// module chunks = 0